import React from "react";
import BoardTabPane from "../common/BoardTabPane";
import { GRID_KEYS, TOP_TABS } from "../constants";
import { getDelDispatchObjectsStore } from "../services/DispatchManagementService";

/**
 * Del tab - the same row scope as Pick, from its own Delphi query (tabTopDelDispatch, caption "&Del",
 * over uFMM0061).
 *
 * What makes it a different tab is the colouring: bands are measured against SCHEDULEDDELIVERYDT
 * using DODELPENDINGLEVEL / DODELWARNINGLEVEL, so the same record can be calm here and red on Pick.
 */
const DelTab = (props) => (
    <BoardTabPane
        {...props}
        topTab={TOP_TABS.DEL}
        gridKey={GRID_KEYS.DEL}
        storeFactory={getDelDispatchObjectsStore}
    />
);

export default DelTab;
